import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Box, Button, Container, Paper, TextField, Typography } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../../Navbar/Navbar";
import baseURL from "../../config";
import Cookies from "js-cookie";
import BgImage from "../../assets/shipimage.jpg";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    checkSessionExpiry();
  }, []);

  const checkSessionExpiry = () => {
    const expiryTime = localStorage.getItem("expiryTime");
    if (!expiryTime || Date.now() > Number(expiryTime)) {
      logout();
    } else {
      autoLogout(Number(expiryTime));
    }
  };

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userData = { email, password };
    const expiryTime = Date.now() + 24 * 60 * 60 * 1000; // Set expiry time to 24 hours

    try {
      const response = await axios.post(`${baseURL}/api/login`, userData);
      if (response.status === 200 && response.data && response.data.user) {
        const user = response.data.user;


        Cookies.set("userEmail", user.email, { expires: 1 });
        localStorage.setItem("userType", user.userType);
        localStorage.setItem("user id", user.id);
        localStorage.setItem("token", response.data.token)

        localStorage.setItem("expiryTime", expiryTime); // Store expiry time
        autoLogout(expiryTime); // Start auto-logout timer here

        if (user.urlId) {
          localStorage.setItem("urlID", user.urlId);
        }

        if (user?.crewingAgentId) {
          localStorage.setItem("crewingAgentId", user.crewingAgentId)
        }

        switch (user.userType) {
          case "crew":
            if (!user.urlId || user.urlId.trim() === "") {
              navigate("/crewprofile");
            } else {
              navigate(`/CrewInfo/${user.urlId}`);
            }
            break;
          case "Vessel_vendor":
            navigate("/Vesselvendor");
            break;
          case "vessel_owner":
            // localStorage.setItem("userEmail", user.email);
            // toast.success("User signed in Successfully!");
            if (!user.urlId || user.urlId.trim() === "") {
              navigate("/vesselownerform");
            } else {
              navigate(`/VesselOwnerLayouts/${user.urlId}`);
            }
            break;
          case "crewing_agent":
            if (!user.urlId || user.urlId.trim() === "") {
              navigate("/Crewing_Agent");  // Redirect if urlId is missing
            } else {
              navigate(`/ContractTable/${user.urlId}`);
            }
            break;
          case "crewingAgent_Executive":
             navigate(`/ContractTable/${user.crewingAgentId}`);
            break;
          case "vessel_manager":
            navigate("/VesselMangerForm");
            break;
          case "executive":
            navigate(`/ExecutiveVesselInfo/${user.urlId}`);
            break;
          case "admin":
            navigate("/AdminDashboard");
            break;
          case "team_leader":
            navigate("/VesselManagerTable");
            break;
          case "BSE":
            navigate("/VesselManagerTable");
            break;
          default:
            toast.error("Unknown user type");
        }
      }
    } catch (error) {
      console.error("Login error:", error.response ? error.response.data : error.message);
      toast.error(error.response ? error.response.data.message : "An error occurred during login");
    }
  };
  const autoLogout = (expiryTime) => {
    const timeRemaining = expiryTime - Date.now();
    // console.log("Auto logout in:", timeRemaining, "ms");

    if (timeRemaining > 0) {
      const timeoutId = setTimeout(() => {
        // console.log("Logging out user now..."); 
        logout();
      }, timeRemaining);

      // console.log("Timeout ID:", timeoutId); 
    } else {
      logout();
    }
  };



  const logout = () => {
    // console.log("Session expired. Logging out...");
    localStorage.clear();
    Cookies.remove("userEmail");
    navigate("/login");
  };


  return (
    <>
      {/* Navbar stays at the top */}
      <Navbar />

      <Box
        sx={{
          width: "100%",
          height: "100vh",
          background: `url(${BgImage}) center/cover no-repeat`,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          position: "relative",
          zIndex: 1,
          // pt: 12,
        }}
      >
        <Container maxWidth="sm">
          <Paper
            elevation={10}
            sx={{ p: 4, borderRadius: 3, backdropFilter: "blur(8px)", bgcolor: "rgba(255, 255, 255, 0.8)" }}
          >
            <Typography variant="h4" fontWeight="bold" mb={2}>
              CrewGenix Login
            </Typography>
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Email"
                variant="outlined"
                margin="normal"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <TextField
                fullWidth
                label="Password"
                variant="outlined"
                margin="normal"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleTogglePassword} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {/* Forgot Password Link */}
              <Box textAlign="right" sx={{ mt: 1, mb: 2 }}>
                <Typography variant="body2">
                  <Link to="/forgotPassword" style={{ textDecoration: "none", color: "#C30B12", fontWeight: "bold" }}>
                    Forgot Password?
                  </Link>
                </Typography>
              </Box>

              <Button
                variant="contained"
                fullWidth
                type="submit"
                sx={{
                  mt: 2,
                  backgroundColor: '#C30B12',
                  '&:hover': {
                    backgroundColor: '#a50a10',
                  },
                }}
              >
                Login
              </Button>

            </form>

            <Typography variant="body2" mt={2}>
              Don't have an account? <Link to="/signup">Sign up</Link>
            </Typography>
          </Paper>
        </Container>
      </Box>

      <ToastContainer position="top-right" autoClose={5000} />
    </>
  );
};

export default Login;
